import { asDate } from "@@/shared/date-time/as-date";
import type { IsoAndUnixTimestamp } from "../../shared/date-time/iso-and-unix";

const getShortDate = (date: IsoAndUnixTimestamp) => {
    const formatter = new Intl.DateTimeFormat(undefined, {
        weekday: "long",
        day: "numeric",
        month: "short",
        year: "numeric",
    });
    return formatter.format(asDate(date));
};

const getDatePart = (date: IsoAndUnixTimestamp) => {
    return Intl.DateTimeFormat("sv-SE").format(asDate(date));
};

const getShortMonthDate = (date: IsoAndUnixTimestamp) => {
    return getShortMonthDateByDate(asDate(date));
};
const getMonthYearDate = (date: IsoAndUnixTimestamp) => {
    return getMonthYearByDate(asDate(date));
};

const getMonthYearByDate = (date: Date) => {
    const formatter = new Intl.DateTimeFormat(undefined, {
        month: "long",
        year: "numeric",
    });
    return formatter.format(date);
};

const getShortMonthDateByDate = (date: Date) => {
    const formatter = new Intl.DateTimeFormat(undefined, {
        weekday: "long",
        day: "numeric",
    });
    return formatter.format(date);
};
export {
    getDatePart,
    getMonthYearDate,
    getShortDate,
    getShortMonthDate,
    getShortMonthDateByDate,
};
